/**
 * Heatmap Logic & Data for HMS Innsikt Platform
 * Oppdatert for å støtte OrganizationalHeatmap.jsx
 */

// 1. Organisasjonsdata som objekt (ikke array)
export const orgHeatmapData = {
  id: "org-1",
  name: "HMS-innsikt Demo-virksomhet",
  health: 78,
  metrics: {
    we: 78,
    stress: 32,
    safety: 82,
    conflict: 14
  },
  departments: [
    {
      id: "dept-1",
      name: "Salg & Marked",
      health: 72,
      metrics: { we: 72, stress: 45, safety: 75, conflict: 28 },
      teams: [
        { 
          id: "team-1-1", 
          name: "Salg Norge", 
          health: 68, 
          metrics: { we: 68, stress: 52, safety: 70, conflict: 35 } 
        },
        { 
          id: "team-1-2", 
          name: "Digital Markedsføring", 
          health: 76, 
          metrics: { we: 76, stress: 38, safety: 80, conflict: 21 } 
        }
      ]
    },
    {
      id: "dept-2",
      name: "Produkt & Utvikling",
      health: 84,
      metrics: { we: 84, stress: 28, safety: 88, conflict: 12 },
      teams: [
        { 
          id: "team-2-1", 
          name: "Frontend Team", 
          health: 86, 
          metrics: { we: 86, stress: 24, safety: 90, conflict: 10 } 
        },
        { 
          id: "team-2-2", 
          name: "Backend & Arkitektur", 
          health: 82, 
          metrics: { we: 82, stress: 32, safety: 86, conflict: 14 } 
        }
      ]
    },
    {
      id: "dept-3",
      name: "Kundeservice",
      health: 64,
      metrics: { we: 64, stress: 58, safety: 68, conflict: 42 },
      teams: [
        { 
          id: "team-3-1", 
          name: "Support Nord", 
          health: 59, 
          metrics: { we: 59, stress: 65, safety: 62, conflict: 48 } 
        },
        { 
          id: "team-3-2", 
          name: "Support Sør", 
          health: 69, 
          metrics: { we: 69, stress: 51, safety: 74, conflict: 36 } 
        }
      ]
    },
    {
      id: "dept-4",
      name: "HR & Administrasjon",
      health: 89,
      metrics: { we: 89, stress: 18, safety: 92, conflict: 8 },
      teams: [
        { 
          id: "team-4-1", 
          name: "HR-Team", 
          health: 91, 
          metrics: { we: 91, stress: 15, safety: 94, conflict: 5 } 
        }
      ]
    }
  ]
};

// 2. Fargekoding som returnerer objekt med farge, hex og label
export const getColorByScore = (score) => {
  if (score >= 85) {
    return {
      color: "green",
      hex: "#10b981",
      label: "Sterkt"
    };
  } else if (score >= 70) {
    return {
      color: "yellow",
      hex: "#f59e0b",
      label: "Moderat"
    };
  } else if (score >= 50) {
    return {
      color: "orange",
      hex: "#f97316",
      label: "Risiko"
    };
  } else {
    return {
      color: "red",
      hex: "#ef4444",
      label: "Kritisk"
    };
  }
};

// 3. Intervensjonsgenerator basert på node-data
export const getHeatmapInterventions = (node) => {
  if (!node) return [];

  const interventions = [];
  const score = node.health || 0;
  const metrics = node.metrics || {};

  // Logikk basert på helseskår
  if (score < 60) {
    interventions.push({
      title: "Kriseintervensjon & Kartlegging",
      impact: "Høy",
      effort: "Middels",
      description: "Umiddelbar oppfølging av arbeidsmiljøet for å identifisere kritiske drivere."
    });
  }

  // Logikk basert på spesifikke metrikker
  if (metrics.stress > 50) {
    interventions.push({
      title: "Stressmestring & Kapasitetsgjennomgang",
      impact: "Middels",
      effort: "Lav",
      description: "Gjennomgang av arbeidsmengde og forventningsavklaring i teamet."
    });
  }

  if (metrics.safety < 70) {
    interventions.push({
      title: "Workshop: Psykologisk Trygghet",
      impact: "Høy",
      effort: "Middels",
      description: "Bygge fundament for åpen kommunikasjon og feiltoleranse."
    });
  }

  if (metrics.conflict > 30) {
    interventions.push({
      title: "Konflikthåndtering & Fasilitert Dialog",
      impact: "Høy",
      effort: "Høy",
      description: "Nøytral tredjepart fasiliterer samtaler for å løse interpersonelle spenninger."
    });
  }

  // Standard intervensjon hvis alt er bra
  if (interventions.length === 0) {
    interventions.push({
      title: "Forebyggende Vedlikehold",
      impact: "Lav",
      effort: "Lav",
      description: "Fortsette gode rutiner og feire suksesser for å opprettholde det gode miljøet."
    });
  }

  return interventions;
};